import React from "react";
export function Mandala({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="-100 -100 200 200" className={className} fill="none" stroke="currentColor" strokeWidth={0.7} aria-hidden="true" data-id="element-170" data-mp="2iisz4r4uykbi">
      <circle r={97} data-id="element-171" data-mp="2dpq1a6t1sopi" />
      <circle r={90} data-id="element-172" data-mp="29qh936dnoyw2" />
      {Array.from({
      length: 36
    }, (_, i) => <circle key={`d${i}`} r={2} cy={-93.5} transform={`rotate(${i * 10})`} data-id="element-173" data-mp="29o4vf5exlaot" />)}
      {Array.from({
      length: 24
    }, (_, i) => <ellipse key={`o${i}`} rx={9} ry={24} cy={-62} transform={`rotate(${i * 15})`} data-id="element-174" data-mp="1zriayhqiolnb" />)}
      <circle r={38} data-id="element-175" data-mp="1usoz0tqvp2p9" />
      {Array.from({
      length: 16
    }, (_, i) => <ellipse key={`m${i}`} rx={6} ry={14} cy={-26} transform={`rotate(${i * 22.5})`} data-id="element-176" data-mp="1uurw1xqg7w3h" />)}
      <circle r={10} data-id="element-177" data-mp="1qtptp818j3xa" />
      {Array.from({
      length: 24
    }, (_, i) => <line key={`s${i}`} y1={-3} y2={-10} transform={`rotate(${i * 15})`} data-id="element-178" data-mp="3p6g21aepcobq" />)}
    </svg>;
}